var _g, _g2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkipLoaderTruckWithTrailer1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 675 243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M32.019 201.75h532.114",
    "data-name": "Line 60"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m34.062 206.25-12.261-4.5 12.261-4.5Z",
    "data-name": "Path 88"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m561.932 206.25 12.261-4.5-12.261-4.5Z",
    "data-name": "Path 89"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M4.5 6.5v165.8",
    "data-name": "Line 62"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "M0 7.8 4.5 0 9 7.8Z",
    "data-name": "Path 92"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m0 171 4.5 7.8L9 171Z",
    "data-name": "Path 93"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 68"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m576.868 177.86 21.2-34.862",
    "data-name": "Line 63"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m581.455 179.06-7.915 4.392.187-8.972Z",
    "data-name": "Path 94"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m601.232 146.475.187-8.972-7.84 4.273Z",
    "data-name": "Path 95"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 145",
    transform: "translate(-926.818 -6332.797)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    fill: "var(--delivery-measurement-color)",
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-measurement-color)",
    d: "M261.043 202.696a2 2 0 0 1 3.4 0l6.914 11.194a2 2 0 0 1-1.7 3.051h-13.828a2 2 0 0 1-1.7-3.051Z",
    "data-name": "Polygon 6"
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "L,L m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(232.742 234.203)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "L,L m")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 150"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 125",
    transform: "translate(-555.506 -6374.74)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.814 6547.788a2 2 0 0 1 .802 2.204l-5.854 20.574a2 2 0 0 1-3.806.132l-11.848-32.568a2 2 0 0 1 3-2.344Z",
    "data-name": "Polygon 2"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "W,W m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(600.494 192.26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "W,W m"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 124",
    transform: "translate(-1133.601 -6535.225)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 33,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6541)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.798 6556.71a2 2 0 0 1 2.204-.8l20.574 5.853a2 2 0 0 1 .132 3.806l-32.568 11.848a2 2 0 0 1-2.344-3Z",
    "data-name": "Polygon 2"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "H,H m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(26.066 28.538)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "H,H m"))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "var(--delivery-color)",
    "data-name": "Group 8",
    transform: "translate(-4334.899 -3774.43)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 25",
    transform: "translate(4434.686 3911.561)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 26",
    transform: "translate(4374.285 3911.561)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 28",
    transform: "translate(4444.786 3921.661)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 29",
    transform: "translate(4384.386 3921.661)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M4417.285 3938.36h20m-20 0h20",
    "data-name": "Line 59"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M4413.886 3922.661h22",
    "data-name": "Line 55"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 25",
    transform: "translate(4522.316 3911.561)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 28",
    transform: "translate(4532.417 3921.661)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 25",
    transform: "translate(4522.316 3911.561)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 28",
    transform: "translate(4532.417 3921.661)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 5,
    d: "M4477.439 3922.661h44.877",
    "data-name": "Path 10"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M4564.487 3922.661h13.834v-15.972h-217",
    "data-name": "Path 11"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M4417.285 3938.36h20m-21.399 0h18",
    "data-name": "Line 59"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M4361.317 3906.689v15.673h13.992",
    "data-name": "Path 12"
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 5.027,
    d: "m4575.713 3930.95 23.885-9.639a3.528 3.528 0 0 1 4.296 2.522 3.528 3.528 0 0 1-2.521 4.296l-25.867 10.408",
    "data-name": "Path 79"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 3.351,
    d: "M4614.933 3922.742c4.205-5.706-4.166-9.604-5.185-3.59-.787 4.503-6.007 4.518-6.007 4.518",
    "data-name": "Path 83"
  })), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 5,
    d: "M4565.543 3938.36h10.324v-15",
    "data-name": "Path 13"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M4477.439 3938.36h45.061",
    "data-name": "Line 59"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M278.213 190.351h285.079",
    "data-name": "Line 61"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m280.037 194.851-10.943-4.5 10.943-4.5Z",
    "data-name": "Path 90"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m561.468 194.851 10.8-4.5-10.8-4.5Z",
    "data-name": "Path 91"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 148"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 145",
    transform: "translate(-760.038 -6337.81)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    fill: "var(--delivery-measurement-color)",
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-measurement-color)",
    d: "M427.787 191.919a2 2 0 0 1 1.735-1.329 2 2 0 0 1 1.736 1.329l7.057 15.724a3.739 3.739 0 0 1 .046 2.844 2.046 2.046 0 0 1-1.782 1.442h-14.114a2.046 2.046 0 0 1-1.782-1.442 3.739 3.739 0 0 1 .046-2.844Z",
    "data-name": "Polygon 6"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "B,B m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(402.523 228.649)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "B,B m")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M30.92 190.351h212.002",
    "data-name": "Line 61"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m32.744 194.851-10.943-4.5 10.943-4.5Z",
    "data-name": "Path 90"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m241.098 194.851 10.8-4.5-10.8-4.5Z",
    "data-name": "Path 91"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 148"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 145",
    transform: "translate(-1065.038 -6337.81)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    fill: "var(--delivery-measurement-color)",
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-measurement-color)",
    d: "M122.787 191.919a2 2 0 0 1 1.735-1.329 2 2 0 0 1 1.736 1.329l7.057 15.724a3.739 3.739 0 0 1 .046 2.844 2.046 2.046 0 0 1-1.782 1.442h-14.114a2.046 2.046 0 0 1-1.782-1.442 3.739 3.739 0 0 1 .046-2.844Z",
    "data-name": "Polygon 6"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "S,S m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(97.523 228.649)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "S,S m")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "var(--delivery-color)",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    strokeWidth: 5.027
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.326 163.39h19.5",
    "data-name": "Line 64"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 74",
    transform: "translate(297.778 18.993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.811 132.397h75.656v-24.4",
    "data-name": "Path 102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.567 132.397h22",
    "data-name": "Line 67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.378 133.363v-1.166c-1.21 0-19.151.172-19.151.172s-9.05.42-9.613-1.036v-15.11c-.61-1.694 5.821-2.024 12.012-2 3.858.011 7.751.2 8.656.2l185.45.278V35.997c0-3.7 2.467-6.7 5.51-6.7h42.35a5.484 5.484 0 0 1 4.77 3.3l25.657 53a14.588 14.588 0 0 1 1.48 6.5v45.6c0 3.7-2.467 6.7-5.51 6.7h-18.134",
    "data-name": "Path 103"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.511 132.397v4.7a6.278 6.278 0 0 0 6.489 6h8.111",
    "data-name": "Path 104"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    "data-name": "Ellipse 30",
    transform: "translate(201.639 118.697)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    "data-name": "Ellipse 31",
    transform: "translate(71.24 118.697)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    "data-name": "Ellipse 32",
    transform: "translate(10.294 118.697)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    "data-name": "Ellipse 33",
    transform: "translate(211.739 128.797)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    "data-name": "Ellipse 34",
    transform: "translate(81.26 128.797)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    "data-name": "Ellipse 35",
    transform: "translate(20.394 128.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.859 59.197h-27.586c-3.056 0-5.534 3-5.534 6.7v13.5c0 3.7 2.478 6.7 5.534 6.7h40.636",
    "data-name": "Path 106"
  }))), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    "data-name": "Group 25",
    transform: "translate(-5991.406 -4661.053)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.9,
    cy: 5.9,
    r: 5.9,
    strokeWidth: 5.027,
    "data-name": "Ellipse 36",
    transform: "translate(6377.688 4739.307)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 5.027,
    d: "m6323.771 4795.064 59.047-44.257",
    "data-name": "Line 68"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 5.027,
    d: "m6311.5 4794.064 67.305-50.257",
    "data-name": "Line 69"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 5.027,
    d: "m6382.154 4739.63-49.674-12.326a3.913 3.913 0 0 0-4.804 2.986 4.017 4.017 0 0 0 3.05 4.881l45.72 10.46",
    "data-name": "Path 105"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 3.351,
    d: "M6317.888 4724.535c-6.715 2.11-2.103 10.25 2.248 5.946 3.267-3.263 7.477-.268 7.477-.268",
    "data-name": "Path 113"
  }))), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M328.267 126.173h-8.162l-34.4-37.32V52.266h164.208v36.587l-34.193 37.32h-71.826",
    "data-name": "Path 18"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M54.079 50.036h163.9v36.953l-34.73 36.679H88.907L54.083 86.989Z",
    "data-name": "Path 21"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipLoaderTruckWithTrailer1);
export default __webpack_public_path__ + "static/media/SkipLoaderTruckWithTrailer1.370cc77b7377f391ed42a1ee9023f926.svg";
export { ForwardRef as ReactComponent };